import React, {Component} from 'react'
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Button, Row, Col} from 'antd';
import * as APP_CONFIG from "../constants/config";
import Action from './Action';
//import {Link} from "react-router-dom";
import moment from 'moment';

const {DateTimeFormat, DateFormat} = APP_CONFIG;

class Malfunction extends Component {

    static propTypes = {
        params: PropTypes.shape({
            id: PropTypes.string.isRequired
        }),
        malfunctions: PropTypes.array.isRequired,
    };

    constructor(props) {
        super();
        this.state = {
            malfunction: this.getMalfunction(props)
        };
    }

    getMalfunction = ({ malfunctions, match }) => {
        let malfunction = null;

        malfunctions.forEach((element) => {
            if(element.id === parseInt(match.params.id,10))
                malfunction = element;
        });

        if(malfunction === null) {
            console.log('malfunction not found with ', match.params.id);

            malfunction = APP_CONFIG.defaults.malfunction;
        }
        return malfunction;
    };

    showActions = (acties) => {
        let tekst = '';
        tekst += acties !== undefined && acties.length ? 'Acties' : 'Nog geen acties';

        return tekst;
    }

    toList = (id) => {
        this.props.history.push('/storingen');
    };

    addActie = (id) => {
        this.props.history.push(`/storingen/${id}/actions/0`);
    };

    toEdit = (id) => {
        this.props.history.push(`/storingen/${id}/edit`);
    };

    sortActions = (a,b) => {
        let diff = moment(b, DateTimeFormat).diff(moment(a, DateTimeFormat));
        return diff < 0 ? -1 : diff > 0 ? 1 : 0;
    };

    render() {
        const { malfunction } = this.state;

        let sortedActions = [];

        if(malfunction.actions.length){
            sortedActions = [...malfunction.actions.sort(this.sortActions)];
        }

        return (
            <div>
                <div>
                    <Row gutter={{xs: 0, md: 24}} className="dataview-row">
                        <Col xs={24} md={5} className="dataview-label" style={{fontWeight:'bold'}}>Klant</Col>
                        <Col xs={24} md={16} className="dataview-value">{malfunction.klant} <Button type="primary" onClick={()=>this.toEdit(malfunction.id)}>Aanpassen</Button>{/*<Link to={`/storingen/${malfunction.id}/edit`} ><Icon type="edit" /></Link>*/}</Col>
                    </Row>
                    <Row gutter={{xs: 0, md: 24}} className="dataview-row">
                        <Col xs={24} md={5} className="dataview-label" style={{fontWeight:'bold'}}>Locatie</Col>
                        <Col xs={24} md={16} className="dataview-value">{malfunction.locatie}</Col>
                    </Row>
                    <Row gutter={{xs: 0, md: 24}} className="dataview-row">
                        <Col xs={24} md={5} className="dataview-label" style={{fontWeight:'bold'}}>Contactpersoon</Col>
                        <Col xs={24} md={16} className="dataview-value">{malfunction.contactpersoon}</Col>
                    </Row>
                    <Row gutter={{xs: 0, md: 24}} className="dataview-row">
                        <Col xs={24} md={5} className="dataview-label" style={{fontWeight:'bold'}}>Aanmeldingsdatum</Col>
                        <Col xs={24} md={16} className="dataview-value">{moment(malfunction.aanmeldingsdatum).format(DateFormat)}</Col>
                    </Row>
                    <Row gutter={{xs: 0, md: 24}} className="dataview-row">
                        <Col xs={24} md={5} className="dataview-label" style={{fontWeight:'bold'}}>Zichtbaar voor klant</Col>
                        <Col xs={24} md={16} className="dataview-value"><input type="checkbox" readOnly={true} checked={malfunction.zichtbaar_voor_klant} /></Col>
                    </Row>
                    <Row gutter={{xs: 0, md: 24}} className="dataview-row">
                        <Col xs={24} md={5} className="dataview-label" style={{fontWeight:'bold'}}>Storingstype</Col>
                        <Col xs={24} md={16} className="dataview-value">{malfunction.storingtype}</Col>
                    </Row>
                    <Row gutter={{xs: 0, md: 24}} className="dataview-row">
                        <Col xs={24} md={5} className="dataview-label" style={{fontWeight:'bold'}}>Storingssubtype</Col>
                        <Col xs={24} md={16} className="dataview-value">{malfunction.storingsubtype}</Col>
                    </Row>
                    <Row gutter={{xs: 0, md: 24}} className="dataview-row">
                        <Col xs={24} md={5} className="dataview-label" style={{fontWeight:'bold'}}>Beschrijving</Col>
                        <Col xs={24} md={16} className="dataview-value">{malfunction.beschrijving}</Col>
                    </Row>
                    <Row gutter={{xs: 0, md: 24}} className="dataview-row">
                        <Col xs={24} md={5} className="dataview-label" style={{fontWeight:'bold'}}>{this.showActions(malfunction.actions)}</Col>
                        <Col xs={24} md={16} className="dataview-value"><Button type="primary" onClick={()=>this.addActie(malfunction.id)}>Toevoegen</Button>{/*<Button type="primary" onClick={this.addActie(malfunction.id)}>Toevoegen</Button>*/}</Col>
                    </Row>
                    {sortedActions.map(function (item, i) {
                        return (
                            <Row key={i} gutter={{xs: 0, md: 24}} className="dataview-row">
                                <Col xs={24} md={5} className="dataview-label" style={{fontWeight:'bold'}}></Col>
                                <Col xs={24} md={16} className="dataview-value"><Action key={i} actie={item} malfunctionid={malfunction.id} /></Col>
                            </Row>

                        )
                    })}
                </div>
                {/*<div style={{width:"100%"}}>
                    <div style={{width:"100%"}}>
                        <div style={{float:"left;width:200px"}}>{this.showActions(malfunction.actions)}</div>
                        <div style={{float:"right;width:200px"}}><Button type="primary" onClick={this.toList}>Toevoegen</Button></div>
                    </div>

                </div>*/}
                <div>
                    {/*<Link to={`/storingen/${malfunction.id}/actions/0`} >
                        <Icon type="plus" />
                    </Link><br/>*/}






                </div>
                <div>
                    <br/>
                </div>
                <div>
                    <p style={{ margin: 0 }}>
                        <Button type="primary" onClick={this.toList}>Overzicht Storingen</Button>&nbsp;

                    </p>
                </div>
            </div>
        );
    }
}

let mapStateToProps = ({malfunctions}) => ({
    malfunctions: [...malfunctions.malfunctions]
});

export default connect(mapStateToProps)(Malfunction);



// WEBPACK FOOTER //
// ./src/components/Malfunction.js